module.exports = __webpack_public_path__ + "img/verify.6d253885.svg";